module.exports = __webpack_public_path__ + "quotation_gray_top.49c1817f.svg";